import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-elearnio-loader',
  templateUrl: './elearnio-loader.component.html',
  styleUrls: ['./elearnio-loader.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class ElearnioLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
